export enum ProductType {
  CvKetel = 'cv-ketel',
  EBoiler = 'e-boiler',
  Heatpump = 'heatpump',
}

export enum OrderType {
  Installation = 'ins',
  Maintenance = 'oh',
}

export enum Gender {
  Man = 'm',
  Woman = 'v',
}

export interface LeadsMachineRequestBody {
  data: {
    FirstName__c: string;
    Prefix__c: string;
    Gender__c: Gender;
    Email_opt_in__c: string;
    LastName__c: string;
    Postal_Code__c: string;
    SuppliedPhone: string;
    SuppliedEmail: string;
    HouseNo__c: string;
    HouseNoAdd__c: string | null;
    Interest_Centralheating__c?: string;
    Interest_Rental_Centralheating__c?: string;
    Interest_Heatpump__c?: string;
    RecordTypeId: string;
  };
}
